<div>
  <p class="title">
    No se ha detectado actividad durante los ultimos 10 minutos... ¿Desea
    mantener la sesion abierta?
  </p>
  <div class="buttons">
    <button
      mat-raised-button
      (click)="dialogRef.close()"
      class="primary-btn rounded"
    >
      Aceptar
    </button>
  </div>
</div>
